<template>
    <div v-if="registration">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-12">

                    <header-card :registration="registration" :simulation="simulation"></header-card>

                    <tabs class="tabs"
                            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pb-3"
                            tabContentClasses="">

                        <tab-pane class="card mb-0" id="instructor-issues">
                            <span slot="title">
                                {{ $t('issues.instructor-issues') }}
                            </span>
                            <issues
                                :registration="registration"
                                :simulation="simulation"
                                role="instructor">
                            </issues>
                        </tab-pane>

                        <tab-pane class="card mb-0" id="pilot-issues">
                            <span slot="title">
                                {{ $t('issues.pilot-issues') }}
                            </span>
                            <issues
                                :registration="registration"
                                :simulation="simulation"
                                role="pilot">
                            </issues>
                        </tab-pane>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HeaderCard from './issues/Header';
    import Issues from './issues/Issues';

    export default {

        components: {
            HeaderCard, Issues
        },

        data() {
            return {
                registration: null,
                simulation: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.issues'),
                        route: '/socrates/ui/dashboard/issues'
                    },
                    {
                        name: this.registration.cohort.name + ' / ' + this.registration.degree.name,
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/issues/registrations/' + to.params.registrationId + '/simulations/' + to.params.simulationId)
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },
    }
</script>
